// Remotion 场景共享设计 token（深色主题，与 SPA 品牌一致）。
// 所有 composition 用这些常量，保证视觉统一 + 专业感。
export const THEME = {
  bg: '#08080c',
  bg2: '#13131a',
  bg3: '#1a1a23',
  border: 'rgba(255,255,255,0.08)',
  // 文本
  w: '#fafafa', // 主标题/高亮
  t: '#e4e4e7', // 正文
  t2: '#a1a1aa', // 次要
  t3: '#71717a', // 弱化
  // 品牌
  p: '#6366f1', // 主色 indigo
  pHover: '#818cf8',
  pSubtle: 'rgba(99,102,241,0.12)',
  // 字体
  fontSans: "Inter,'Noto Sans SC',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
  fontMono: "ui-monospace,SFMono-Regular,'JetBrains Mono',Menlo,monospace",
  // 设计坐标（composition 原生像素）
  W: 1080,
  H: 1920,
  fps: 30,
} as const

// 常用缓动（Remotion 的 Easing 包再导出便利）
export { Easing } from 'remotion'
